import { CloudWatchLogsClient } from '@aws-sdk/client-cloudwatch-logs'

export const LOG_GROUP = process.env.NEXT_PUBLIC_CLOUD_WATCH_LOG_GROUP

export const LOG_STREAM = 'autocomplete-events'

export const client = new CloudWatchLogsClient({
  region: process.env.AWS_REGION || 'ap-northeast-2',
})
